import React from 'react';

import { flagStyles } from '../settings';

const SvgPA = (): JSX.Element => (
  <img
    style={{
      backgroundPosition: '-4104px 0px',
      ...flagStyles
    }}
    alt=""
  />
);

export default SvgPA;
